'use client';

import { cn } from '@/lib/utils';

const variants: Record<string, string> = {
  ativo: 'bg-admin-success/10 text-admin-success border-admin-success/20',
  inativo: 'bg-admin-text-secondary/10 text-admin-text-secondary border-admin-text-secondary/20',
  pendente: 'bg-admin-warning/10 text-admin-warning border-admin-warning/20',
  agendado: 'bg-admin-cyan/10 text-admin-cyan-dark border-admin-cyan/20',
  'em andamento': 'bg-admin-warning/10 text-admin-warning border-admin-warning/20',
  concluido: 'bg-admin-success/10 text-admin-success border-admin-success/20',
  concluído: 'bg-admin-success/10 text-admin-success border-admin-success/20',
  cancelado: 'bg-destructive/10 text-destructive border-destructive/20',
  enviado: 'bg-admin-success/10 text-admin-success border-admin-success/20',
  falhou: 'bg-destructive/10 text-destructive border-destructive/20',
  sent: 'bg-admin-success/10 text-admin-success border-admin-success/20',
  contacted: 'bg-admin-cyan/10 text-admin-cyan-dark border-admin-cyan/20',
  scheduled: 'bg-admin-warning/10 text-admin-warning border-admin-warning/20',
  cancelled: 'bg-destructive/10 text-destructive border-destructive/20',
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize',
        variants[status.toLowerCase()] || variants.pendente
      )}
    >
      {status}
    </span>
  );
}

